module.exports = __webpack_public_path__ + "img/sonata-25.fcab2f60.png";